import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.workSheetApi + '/worksheet/api/v1/'

export const GetTimeIntervalAmount = (data) => {
  return axios.request({
    url: baseUrl + 'time_interval_count/',
    data: data,
    method: 'post'
  })
}

export const GetTypeSonCount = (data) => {
  return axios.request({
    url: baseUrl + 'type_son_count/',
    data: data,
    method: 'post'
  })
}

export const GetAllCount = (params) => {
  return axios.request({
    url: baseUrl + 'all_count/',
    params: params,
    method: 'get'
  })
}
